// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XJZB","right":"styles_right__1dl1u"};